import React from 'react'
import { API_BO } from '../conf'
import Home from '../pages/home/Home'
import MaterialWorkLoad from '../components/loadMaterialWork/MaterialLoad'

import * as facility from '../pages/facility/index'
import * as facilityAccess from '../pages/facilityAccess/index'
import * as facilityMachine from '../pages/facilityMachine/index'
import * as facilityFiles from '../pages/facilityFiles/index'
import * as orders from '../pages/orders/index'
import * as material from '../pages/material/index'

import ProjectAdd from '../pages/projectAdd/ProjectAdd'
import ProjectSettings from '../pages/projectSettings/ProjectSettings'
import StorageMaterial from '../pages/storageMaterial/StorageMaterial'
import StorageDynamics from '../pages/storageMaterial/StorageDynamics';
// Пока отключим не реализован 
// import WorkAddMany from '../pages/work/WorkAddMany'
import * as work from '../pages/work/index'
// import WorkAddOne from '../pages/work/WorkAddOne'
// import WorkList from '../pages/work/WorkList'
// import WorkLoad from '../pages/work/WorkLoad'
// import WorkEdit from '../pages/work/WorkEdit'
// import WorkPrice from '../pages/work/WorkPrice'
//list
import * as equipment from '../pages/list/equipment/index'
import * as users from '../pages/list/users/index';
import * as provider from '../pages/list/provider/index'
import * as storageUnit from '../pages/list/storageUnit/index';
import * as workTemplate from '../pages/list/workTempalte/index';
import * as position from '../pages/list/position/index';
import * as reportTemplates from '../pages/list/reportTemplates/index'
import * as companies from '../pages/list/companies/index'
import * as workEstimate from '../pages/work-estimate/index'
import * as resources from '../pages/list/resources/index'
import * as machine from '../pages/list/machine/index'
import * as checklist from '../pages/list/checklist/index'
// documents
// import * as AOC from '../pages/documents/actOfCompetitiotn/index'
import * as shipmentConsumables from '../pages/documents/shipmentConsumables/index'
import * as UseTool from '../pages/documents/useTool/index'
import * as removalPMaterial from '../pages/documents/removalPMaterial/index'
import * as ToolWrite from '../pages/documents/toolWrite/index'
import * as shipmentMaterial from '../pages/documents/shipmentMaterial/index'
import * as arendaEquipment from '../pages/documents/arendaEquipment/index'
import * as reciptMaterials from '../pages/documents/receiptMaterials/index'
import * as orderMaterialProvider from '../pages/documents/orderProvider/index'
// import * as storageEquipmentRemoval from '../pages/storageEquipment/index';
import * as acceptance from '../pages/acceptance/index'
import * as worker from '../pages/worker/index'
import * as profile from '../pages/profile/index'
import * as menu from '../pages/menu/index'
import * as workerRating from '../pages/workerrating/index'
import * as ourStorage from '../pages/storage/index'
import * as Analytics from '../pages/projectAnalitycs/index'
import * as projectWorker from '../pages/projectWorker/index'
import * as InventoryList from '../pages/inventory/index'
import * as estimate from '../pages/estimate/index'
import * as outfitPlan from '../pages/documents/orderOutfitPlan/index'
import * as outfitFact from '../pages/documents/orderOutfitFact/index'
import * as outfitDay from '../pages/outfitDay/index'
import * as moveStorage from '../pages/documents/moveStorage/index'
import * as carRental from '../pages/documents/carRental/index'
import * as team from '../pages/team/index'
import * as ocr from '../pages/ocr/index'
import * as workDoc from '../pages/workDoc/index'
import * as formks2 from '../pages/ks2/index'
import * as formks3 from '../pages/ks3/index'
import * as journalsCables from '../pages/journalsCables/index'
import * as accounts from '../pages/accounts/index'
import * as acts from '../pages/acts/index';
import * as inputControl from '../pages/inputControl/index';
import * as waybill from '../pages/waybill/index';
import * as remarks from '../pages/remarks/index';
import * as tenderOur from '../pages/tenderOur/index'
import * as tender from '../pages/tender/index'
import * as vlm from '../pages/vlm/index'
// import * as StorageInventory from '../pages/storageInventory/index'
import Workplace from '../pages/workplase/Workplace'
import LoadGrand from '../pages/grand/LoadGrand'
import AnalyticsMenu from '../pages/menu/AnalyticMenu'
import Test from '../pages/test/Test'
import OrderMaterialProvider from '../pages/documents/orderMaterialProvider/OrderMaterialProvider'
import * as multiProject from '../pages/multiProject/index'
import Gant from '../pages/gant/Gant'
import GantPrice from '../pages/gant-price/GantPrice'
import GantShare from '../pages/gant-share/GantShare'
import Schedule from '../pages/schedule/Schedule'
import Calendar from '../pages/calendar/Сalendar'
import ZhorList from '../pages/documents/zhor/ZhorLIst'
import * as certificates from '../pages/certificates/index'
import * as machineCalendar from '../pages/machineCalendar/index'
import * as contractor from '../pages/contractor/index'
import * as welding from '../pages/welding/index'
import { SLUGS } from 'src/enum/permissions.enum'

const ADD = '/add';
const ID = '/:id';
const project = API_BO + '/projects/:idProject'
const pAnalytic = project + '/analytics';
const pWorker = project + '/worker';
const pWork = project + '/work';
const pUseTool = project + '/usetool';
const pUseToolTransfer = pUseTool + '/transfer';
const pUseToolAcept = pUseTool + '/acceptance';
const pEstimate = project + '/estimate'
const pCertificates = project + '/certificates'
const pWayBill = project + '/waybill'
const pWelding = project + '/welding'

const pStorage = API_BO + '/projects/:idProject/storage';
const pStorageMaterial = pStorage + '/materials';
const pStorageMaterialMove = pStorageMaterial + '/move';
// const pStorageEquipment = pStorage + '/equipment';
const pStorageInventory = pStorage + '/inventory';

const pShipmentMaterials = project + '/shipment/materials';
const pShipmentEquipment = project + '/shipment/equipment';
const pCarRental = project + '/shipment/carrental'
const pShipmentOrder = project + '/shipment/order';
const pShipmentRent = API_BO + '/projects/:id/shipment/rent';
const pReceptMaterials = API_BO + '/projects/:id/receipt/materials';
const pAcceptance = API_BO + '/projects/:id/acceptance'
const pDelivery = API_BO + '/projects/:id/delivery'
// const pAOC = API_BO + '/projects/:id/aoc';
const pMaterial = API_BO + '/projects/:id/material';
const pOrder = project + '/orders';
const pSettings = project + '/settings'
const pInputControl = project + '/input-control'
const pMachineCalendar = project + '/machine-calendar'
const pListCalendar = project + '/machine-list'
const pMachineWorkplace = project + '/machine-workplace'

const storage = API_BO + '/storage';
const sBldg = storage + '/bldg';
const sDoc = storage + '/doc';
const sDocAddMaterial = sDoc + '/addmaterial';
const sDocMoveProject = sDoc + '/move/project';

const sReport = storage + '/report';

const pUsers = API_BO + '/users';
const pFacility = API_BO + '/facility';
const workerPath = API_BO + '/worker';
const workerRatingPath = workerPath + '/rating';
const pProfile = API_BO + '/profile';
const pProvider = API_BO + '/provider';
const pEquipment = API_BO + '/equipment';
const pCompanies = API_BO + '/companies';
const pChecklist = API_BO + '/checklist';
const pWorkEstimate = API_BO + '/work-estimate';
const pResources = API_BO + '/resources';
const pPosition = API_BO + '/position';
const pMachine = API_BO + '/machine';
const pStorageUnit = API_BO + '/storageunit';
const pTemplates = API_BO + '/templates';
const pInventory = API_BO + '/inventory';
const pWorkTemplate = API_BO + '/worktemplate';
const pInventoryMoveProject = pInventory + '/move/project';

const pRemoval = '/removal';
const pRemovalAdd = '/removal/add';
const pRemovalId = '/removal/:idRemoval';

const pShare = '/share/:id'
const pOutfitPlan = project + '/outfit/plan'
const pOutfitFact = project + '/outfit/fact'
const pZhorList = project + '/zhor'
const pOutfitPlanFact = project + '/outfit/planfact'
const pRemarks = project + '/remarks'
const pProd = project + '/prodmenu'
const pTeam = project + '/team'
const pIHW = project + '/act/ihw'
const pOcr = project + '/ocr'
const pOcrDoc = pOcr + '/doc'
const pOcrR = pOcr + '/recognition'
const pOcrT = pOcr + '/tack'
const pJournalsCables = project + '/journal_cables'
const pWorkDoc = API_BO + '/workdoc'

const pKs2 = project + '/form/ks2'
const pKs3 = pFacility + '/:idFacility/form/ks3'
const pResponsiblePerson = pFacility + '/:idFacility/responsible'
const pFacilityMachine = pFacility + '/:idFacility/machine'
const pFacilityFiles = pFacility + '/:idFacility/files'
const pGant = project + '/form/gant'
const pSchedule = project + '/form/schedule'

const pAccounts = '/accounts'

const pOrderMaterialProvider = project + '/order/provider'

const pCalendar = project + '/calendar'
const pContractor = project + '/contractor'

const pTender = API_BO + '/tender'
const pTenderOur = pTender + '/our'
const pTenderAll = pTender + '/all'

const pVlm = API_BO + '/vlm'

export default function rout() {
  return [
    { path: API_BO + '/', component: Home },
    // { path: API_BO + '/test', component: Test },

    { path: API_BO + pAccounts, component: accounts.list },
    { path: API_BO + '/lists', component: menu.list },
    { check: SLUGS.USER.ENTERA_MANAGE, path: API_BO + '/ocr/setting', component: ocr.ocrSetting },
    { path: pProfile, component: profile.profile },
    { path: pProfile + '/edit', component: profile.edit },
    { path: pProfile + '/editpass', component: profile.editPass },
    // { check: SLUGS.PROJECT.ROOT.CREATE, path: API_BO + '/projects/add', component: ProjectAdd },
    { path: project, component: menu.project },
    { path: project + '/documents', component: menu.document },
    { path: project + '/est-menu', component: menu.estimate },
    // { path: project + '/workplace', component: Workplace },

    { path: API_BO + '/multi', component: menu.multi },
    { check: SLUGS.PROJECT.ESTIMATE_LOAD.EXCEL_FILE, path: API_BO + '/multi/material/load', component: multiProject.loadMaterial },
    { check: SLUGS.PROJECT.ROOT.LIST, path: API_BO + '/multi/material', component: multiProject.getMaterial },

    // tender our
    { check: SLUGS.TENDER.ALL, path: pTender, component: menu.tender },
    { check: SLUGS.TENDER.ALL, path: pTenderOur, component: tenderOur.list },
    { check: SLUGS.TENDER.ALL, path: pTenderOur + ADD, component: tenderOur.add },
    { check: SLUGS.TENDER.ALL, path: pTenderOur + '/:idDoc', component: tenderOur.one },
    { check: SLUGS.TENDER.ALL, path: pTenderOur + '/:idDoc/lots/add', component: tenderOur.addLot },
    // tender all
    { check: SLUGS.TENDER.ALL, path: pTenderAll + '/open', component: tender.openList },
    { check: SLUGS.TENDER.ALL, path: pTenderAll + '/open/:idDoc', component: tender.openOne },
    { check: SLUGS.TENDER.ALL, path: pTenderAll + '/close', component: tender.closeOne },
    { check: SLUGS.TENDER.ALL, path: pTenderAll + '/my-request', component: tender.myList },
    { check: SLUGS.TENDER.ALL, path: pTenderAll + '/my-request/:idDoc', component: tender.myOne },

    //vlm
    { check: SLUGS.OCR, path: pVlm, component: vlm.list },
    { check: SLUGS.OCR, path: pVlm + ADD, component: vlm.add },
    { check: SLUGS.OCR, path: pVlm + '/:idDoc', component: vlm.one },

    // work doc
    { check: SLUGS.WORK_DOC.READ, path: pWorkDoc, component: workDoc.list },
    { check: SLUGS.WORK_DOC.MANAGE, path: pWorkDoc + ADD, component: workDoc.add },
    { check: SLUGS.WORK_DOC.READ, path: pWorkDoc + '/:idDoc', component: workDoc.one },
    { check: SLUGS.WORK_DOC.READ, path: pWorkDoc + '/:idDoc/props', component: workDoc.props },
    // form ks2
    { check: SLUGS.PROJECT.FROM_KS.READ, path: pKs2, component: formks2.list },
    { check: SLUGS.PROJECT.FROM_KS.READ, path: pKs2 + '/table', component: formks2.table },
    { check: SLUGS.PROJECT.FROM_KS.CREATE, path: pKs2 + ADD, component: formks2.add },
    { check: SLUGS.PROJECT.FROM_KS.READ, path: pKs2 + '/:idDoc', component: formks2.one },

    { check: SLUGS.PROJECT.CALENDAR_MACHINE.READ, path: pMachineCalendar, component: machineCalendar.calendar },
    { check: SLUGS.PROJECT.CALENDAR_MACHINE.READ, path: pMachineWorkplace, component: machineCalendar.workplace },
    { check: SLUGS.PROJECT.CALENDAR_MACHINE.READ, path: pListCalendar, component: machineCalendar.list },
    { check: SLUGS.PROJECT.CALENDAR_MACHINE.READ, path: pListCalendar + '/:idDoc', component: machineCalendar.one },
    // gant
    { check: SLUGS.PROJECT.GRANT.READ, path: pGant, component: Gant },
    { check: SLUGS.PROJECT.GRANT.READ, path: pGant + '/price', component: GantPrice },
    { check: SLUGS.PROJECT.CALENDAR.READ, path: pSchedule, component: Schedule },
    // zhor
    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, path: pZhorList, component: ZhorList },
    // welding 
    { check: SLUGS.PROJECT.WELDING.READ, path: pWelding, component: welding.weldingLogList },
    { check: SLUGS.PROJECT.WELDING.MANAGE, path: pWelding + ADD, component: welding.weldingLogAdd },

    { check: SLUGS.PROJECT.WELDING.READ, path: pWelding + '/welders', component: welding.weldersList },
    { check: SLUGS.PROJECT.WELDING.MANAGE, path: pWelding + '/welders' + ADD, component: welding.weldersAdd },
    { check: SLUGS.PROJECT.WELDING.READ, path: pWelding + '/welders' + ID, component: welding.weldersOne },
    { check: SLUGS.PROJECT.WELDING.READ, path: pWelding + '/welders_e', component: welding.weldersEList },
    { check: SLUGS.PROJECT.WELDING.MANAGE, path: pWelding + '/welders_e' + ADD, component: welding.weldersEAdd },
    { check: SLUGS.PROJECT.WELDING.READ, path: pWelding + '/welders_e' + ID, component: welding.weldersEOne },

    { check: SLUGS.PROJECT.WELDING.READ, path: pWelding + ID, component: welding.weldingLogIdList },
    { check: SLUGS.PROJECT.WELDING.MANAGE_RECORDS, path: pWelding + ID + ADD, component: welding.weldingLogIdAdd },
    // analytics -------------------
    { path: pAnalytic, component: AnalyticsMenu },
    { check: SLUGS.PROJECT.ANALYTICS.PROJECT, path: pAnalytic + '/project', component: Analytics.project },
    { check: SLUGS.PROJECT.ANALYTICS.MATERIAL, path: pAnalytic + '/material', component: Analytics.material },
    { check: SLUGS.PROJECT.ANALYTICS.WORKER, path: pAnalytic + '/worker', component: Analytics.projectWorker },
    //  ---------------------------
    // project worker -------------
    { check: SLUGS.PROJECT.WORKER.READ, path: pWorker, component: projectWorker.list },
    { check: SLUGS.PROJECT.WORKER.MANAGE, path: pWorker + ADD, component: projectWorker.add },
    { check: SLUGS.PROJECT.WORKER.READ, path: pWorker + '/attent', component: projectWorker.attend },
    { check: SLUGS.PROJECT.WORKER.READ, path: pWorker + '/resources', component: projectWorker.resources },
    { check: SLUGS.PROJECT.WORKER.READ, path: pWorker + '/ending', component: projectWorker.ending },
    // remarks 
    { check: SLUGS.PROJECT.REMARK.READ, path: pRemarks, component: remarks.list },
    { check: SLUGS.PROJECT.REMARK.CREATE, path: pRemarks + ADD, component: remarks.add },
    { check: SLUGS.PROJECT.REMARK.READ, path: pRemarks + '/:idDoc', component: remarks.one },
    //  ---------------------------
    { check: SLUGS.PROJECT.ROOT.UPDATE, path: pSettings, component: ProjectSettings },
    { path: pStorage, component: menu.storage },
    { check: SLUGS.DOC.REMOVAL_P.READ, path: pStorageMaterial, component: StorageMaterial },
    { check: SLUGS.DOC.REMOVAL_P.READ, path: pStorageMaterial + pRemoval, component: removalPMaterial.list },
    { check: SLUGS.DOC.REMOVAL_P.MANAGE, path: pStorageMaterial + pRemovalAdd, component: removalPMaterial.add },
    { check: SLUGS.DOC.REMOVAL_P.READ, path: pStorageMaterial + pRemovalId, component: removalPMaterial.one },
    { check: SLUGS.PROJECT.STORAGE.READ, path: pStorageMaterial + '/dynamics', component: StorageDynamics },
    // move storage
    { check: SLUGS.PROJECT.STORAGE.MOVE_READ, path: pStorageMaterialMove, component: moveStorage.list },
    { check: SLUGS.PROJECT.STORAGE.MOVE_CREATE, path: pStorageMaterialMove + ADD, component: moveStorage.add },
    { check: SLUGS.PROJECT.STORAGE.MOVE_READ, path: pStorageMaterialMove + '/:idDoc', component: moveStorage.one },
    // car rental
    { check: SLUGS.DOC.CAR_RENTAL.READ, path: pCarRental, component: carRental.list },
    { check: SLUGS.DOC.CAR_RENTAL.MANAGE, path: pCarRental + ADD, component: carRental.add },
    { check: SLUGS.DOC.CAR_RENTAL.READ, path: pCarRental + '/:idDoc', component: carRental.one },
    // delivery input control
    { check: SLUGS.PROJECT.INPUT_CONTROL.READ, path: pInputControl, component: inputControl.list },
    { check: SLUGS.PROJECT.INPUT_CONTROL.READ, path: pInputControl + '/:idDoc', component: inputControl.one },
    // project/:idProject/certificates
    { check: SLUGS.PROJECT.CERTIFICATES.READ, path: pCertificates, component: certificates.list },
    { check: SLUGS.PROJECT.CERTIFICATES.MANAGE, path: pCertificates + ADD, component: certificates.add },
    { check: SLUGS.PROJECT.CERTIFICATES.READ, path: pCertificates + '/:idDoc', component: certificates.one },

    { check: SLUGS.PROJECT.WAYBILL.READ, path: pWayBill, component: waybill.list },
    { check: SLUGS.PROJECT.WAYBILL.READ, path: pWayBill + '/:idDoc', component: waybill.one },
    { check: SLUGS.PROJECT.WAYBILL.MANAGE, path: pWayBill + '/:idDoc/edit', component: waybill.edit },

    // deprecated может дальше будем использовать но пока нет
    // { path: pStorageEquipment, component: storageEquipmentRemoval.list },
    // { path: pStorageEquipment + pRemoval, component: storageEquipmentRemoval.removalList },
    // { path: pStorageEquipment + pRemovalAdd, component: storageEquipmentRemoval.removalAdd },
    // { path: pStorageEquipment + pRemovalId, component: storageEquipmentRemoval.removalById },
    //------------------------

    { check: SLUGS.STORAGE.INVENTORY.READ, path: pStorageInventory, component: InventoryList.projectList },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_READ, path: pStorageInventory + pRemoval, component: InventoryList.moveSList },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_MANAGE, path: pStorageInventory + pRemovalAdd, component: InventoryList.moveSAdd },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_READ, path: pStorageInventory + pRemovalId, component: InventoryList.movePById },

    { path: pProd, component: menu.prod },

    { check: SLUGS.PROJECT.DELIVERY.DOC, path: pDelivery + '/material', component: acceptance.material },
    { check: SLUGS.PROJECT.DELIVERY.DOC, path: pDelivery + '/doc', component: acceptance.list },
    { check: SLUGS.PROJECT.DELIVERY.DOC, path: pDelivery + '/doc/:idAccept', component: acceptance.one },

    { check: SLUGS.PROJECT.DELIVERY.READ, path: pAcceptance, component: acceptance.listDoc },
    { check: SLUGS.PROJECT.DELIVERY.READ, path: pAcceptance + '/:idAccept', component: acceptance.oneDoc },

    // { path: pAOC, component: AOC.list },
    // { path: pAOC + ADD, component: AOC.add },
    // { path: pAOC + '/:idDoc', component: AOC.one },

    { check: SLUGS.PROJECT.SHIPMENT.RECEIPT.READ, path: pReceptMaterials, component: reciptMaterials.list },
    { check: SLUGS.PROJECT.SHIPMENT.RECEIPT.MANAGE, path: pReceptMaterials + ADD, component: reciptMaterials.add },
    { check: SLUGS.PROJECT.SHIPMENT.RECEIPT.READ, path: pReceptMaterials + '/:idDoc', component: reciptMaterials.one },

    { check: SLUGS.DOC.MAT_ORDER_P.READ, path: pOrderMaterialProvider, component: orderMaterialProvider.list },
    { check: SLUGS.DOC.MAT_ORDER_P.MANAGE, path: pOrderMaterialProvider + ADD, component: orderMaterialProvider.add },
    { check: SLUGS.DOC.MAT_ORDER_P.READ, path: pOrderMaterialProvider + '/summary', component: orderMaterialProvider.summary },
    { check: SLUGS.DOC.MAT_ORDER_P.READ, path: pOrderMaterialProvider + '/:idDoc', component: orderMaterialProvider.one },
    { check: SLUGS.DOC.MAT_ORDER_P.MANAGE, path: pOrderMaterialProvider + '/:idDoc/edit', component: orderMaterialProvider.edit },

    { check: SLUGS.PROJECT.ORDER.PRODUCTION, path: pOrder + '/my', component: orders.my },
    { check: SLUGS.PROJECT.ORDER.PRODUCTION, path: pOrder + '/my' + ADD, component: orders.myAdd },
    { check: SLUGS.PROJECT.ORDER.READ_FEED, path: pOrder + '/lenta', component: orders.lenta },
    { check: SLUGS.PROJECT.ORDER.UPDATE_FEED, path: pOrder + '/process', component: orders.processing },

    { check: SLUGS.PROJECT.TEAM.READ, path: pTeam, component: team.list },
    { check: SLUGS.PROJECT.TEAM.MANAGE, path: pTeam + ADD, component: team.add },
    { check: SLUGS.PROJECT.TEAM.READ, path: pTeam + '/:idTeam', component: team.one },

    // /projects/:idProject/act/ihw
    { check: SLUGS.DOC.INSP_HID_W.READ, path: pIHW, component: acts.ahwList },
    { check: SLUGS.DOC.INSP_HID_W.MANAGE, path: pIHW + ADD, component: acts.ahwAdd },
    { check: SLUGS.DOC.INSP_HID_W.READ, path: pIHW + ID, component: acts.ahwOne },

    { check: SLUGS.PROJECT.OCR_ENTERA, path: pOcrDoc, component: ocr.list },
    { check: SLUGS.PROJECT.OCR_ENTERA, path: pOcrDoc + '/:idDoc', component: ocr.one },
    { check: SLUGS.PROJECT.OCR_ENTERA, path: pOcrR, component: ocr.ocrStart },
    { check: SLUGS.PROJECT.OCR_ENTERA, path: pOcrT, component: ocr.tackList },

    { check: SLUGS.PROJECT.MATERIAL.READ, path: pMaterial, component: material.list },
    { check: SLUGS.PROJECT.ESTIMATE_LOAD.EXCEL_FILE, path: pMaterial + '/load', render: (props) => <MaterialWorkLoad {...props} isMaterial={true} /> },
    { check: SLUGS.PROJECT.ESTIMATE_LOAD.GRAND_FILE, path: pMaterial + '/grand', component: LoadGrand },
    { check: SLUGS.PROJECT.MATERIAL.READ, path: pMaterial + '/basket', component: material.basket },
    { check: SLUGS.PROJECT.ESTIMATE_LOAD.EXCEL_FILE, path: pMaterial + '/doc', component: material.loadFromDoc },
    { check: SLUGS.PROJECT.MATERIAL.UPDATE, path: pMaterial + '/price', component: material.price },
    { check: SLUGS.PROJECT.ESTIMATE_LOAD.EXCEL_FILE, path: pMaterial + ADD, component: material.add },
    { check: SLUGS.PROJECT.MATERIAL.READ, path: pMaterial + '/:idMaterial', component: material.one },
    { check: SLUGS.PROJECT.MATERIAL.UPDATE, path: pMaterial + '/:idMaterial/edit', component: material.edit },
    { check: SLUGS.PROJECT.MATERIAL.READ, path: pMaterial + '/:idMaterial/history', component: material.history },

    { check: SLUGS.PROJECT.SHIPMENT.MATERIAL.READ, path: pShipmentMaterials, component: shipmentMaterial.list },
    { check: SLUGS.PROJECT.SHIPMENT.MATERIAL.MANAGE, path: pShipmentMaterials + ADD, component: shipmentMaterial.add },
    { check: SLUGS.PROJECT.SHIPMENT.MATERIAL.READ, path: pShipmentMaterials + '/:idShipment', component: shipmentMaterial.one },
    // { path: pShipmentMaterials + '/:idShipment/:idMaterial/edit', component: shipmentMaterial.oneAdd },  пока выключена 

    { check: SLUGS.PROJECT.SHIPMENT.EQUIPMENT.READ, path: pShipmentEquipment, component: shipmentConsumables.list },
    { check: SLUGS.PROJECT.SHIPMENT.EQUIPMENT.MANAGE, path: pShipmentEquipment + ADD, component: shipmentConsumables.add },
    { check: SLUGS.PROJECT.SHIPMENT.EQUIPMENT.READ, path: pShipmentEquipment + '/:idShipment', component: shipmentConsumables.one },
    { check: SLUGS.PROJECT.SHIPMENT.EQUIPMENT.READ, path: pShipmentEquipment + '/:idShipment/add', component: shipmentConsumables.oneAdd },
    { check: SLUGS.PROJECT.SHIPMENT.EQUIPMENT.MANAGE, path: pShipmentEquipment + '/:idShipment/:idMaterial/edit', component: shipmentConsumables.oneAdd },

    { check: SLUGS.PROJECT.SHIPMENT.RECEIPT.READ, path: pShipmentOrder, component: OrderMaterialProvider },

    { check: SLUGS.PROJECT.SHIPMENT.RENT.READ, path: pShipmentRent, component: arendaEquipment.list },
    { check: SLUGS.PROJECT.SHIPMENT.RENT.MANAGE, path: pShipmentRent + ADD, component: arendaEquipment.add },
    { check: SLUGS.PROJECT.SHIPMENT.RENT.READ, path: pShipmentRent + '/list', component: arendaEquipment.listWriteOff },
    { check: SLUGS.PROJECT.SHIPMENT.RENT.READ, path: pShipmentRent + '/list/:idArenda', component: arendaEquipment.byIdWriteOff },

    { check: SLUGS.PROJECT.WORK.READ, path: pWork, component: work.list },
    { check: SLUGS.PROJECT.WORK.MANAGE, path: pWork + '/basket', component: work.basket },
    { check: SLUGS.PROJECT.WORK.MANAGE_RESOURCE, path: pWork + ADD, component: work.addOne },
    { check: SLUGS.PROJECT.WORK.MANAGE, path: pWork + '/price', component: work.price },
    { check: SLUGS.PROJECT.WORK.MANAGE_RESOURCE, path: pWork + '/load-template', component: work.load },
    { check: SLUGS.PROJECT.ESTIMATE_LOAD.EXCEL_FILE, path: pWork + '/load', render: (props) => <MaterialWorkLoad {...props} isMaterial={false} /> },
    { check: SLUGS.PROJECT.WORK.MANAGE, path: pWork + ID, component: work.edit },

    { check: SLUGS.PROJECT.TOOL_UW.USE_READ, path: pUseToolTransfer, component: UseTool.list },
    { check: SLUGS.PROJECT.TOOL_UW.USE_MANAGE, path: pUseToolTransfer + ADD, component: UseTool.add },
    { check: SLUGS.PROJECT.TOOL_UW.USE_READ, path: pUseToolTransfer + ID, component: UseTool.one },
    { check: SLUGS.PROJECT.TOOL_UW.WRITE_READ, path: pUseToolAcept, component: ToolWrite.list },
    { check: SLUGS.PROJECT.TOOL_UW.WRITE_MANAGE, path: pUseToolAcept + ADD, component: ToolWrite.add },
    { check: SLUGS.PROJECT.TOOL_UW.WRITE_READ, path: pUseToolAcept + ID, component: ToolWrite.one },

    { check: SLUGS.USER.READ, path: pUsers, component: users.list },
    { check: SLUGS.USER.CREATE, path: pUsers + ADD, component: users.add },
    { check: SLUGS.USER.READ, path: pUsers + '/:idUser', component: users.one },

    { check: SLUGS.PROJECT.OUTFIT.PLAN_READ, path: pOutfitPlan, component: outfitPlan.list },
    { check: SLUGS.PROJECT.OUTFIT.PLAN_READ, path: pOutfitPlan + '/day', component: outfitDay.plan },
    { check: SLUGS.PROJECT.OUTFIT.PLAN_CREATE, path: pOutfitPlan + ADD, component: outfitPlan.add },
    { check: SLUGS.PROJECT.OUTFIT.PLAN_READ, path: pOutfitPlan + '/:id', component: outfitPlan.one },
    { check: SLUGS.PROJECT.OUTFIT.PLAN_UPDATE, path: pOutfitPlan + '/:id/edit', component: outfitPlan.edit },
    { check: SLUGS.PROJECT.OUTFIT.FACT_CREATE, path: pOutfitPlan + '/:id/set', component: outfitPlan.setPlan },

    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, path: pOutfitFact, component: outfitFact.list },
    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, path: pOutfitFact + '/day', component: outfitDay.fact },
    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, path: pOutfitFact + '/:id', component: outfitFact.one },

    { check: SLUGS.PROJECT.OUTFIT.FACT_READ, path: pOutfitPlanFact + '/day', component: outfitDay.planfact },

    { check: SLUGS.CATALOG.PROVIDER.READ, path: pProvider, component: provider.list },
    { check: SLUGS.CATALOG.PROVIDER.MANAGE, path: pProvider + ADD, component: provider.add },
    { check: SLUGS.CATALOG.PROVIDER.READ, path: pProvider + '/:idProvider', component: provider.one },
    { check: SLUGS.CATALOG.PROVIDER.MANAGE, path: pProvider + '/:idProvider/edit', component: provider.edit },

    { check: SLUGS.FACILITY.READ_ALL, path: pFacility, component: facility.list },
    { check: SLUGS.FACILITY.CREATE, path: pFacility + ADD, component: facility.add },
    { path: pFacility + '/our', component: facility.our },
    { path: pFacility + '/our' + ID, component: facility.ourOne },
    { path: pFacility + '/our' + ID + '/menu', component: menu.facility },
    { check: SLUGS.FACILITY.READ_ALL, path: pFacility + ID, component: facility.one },
    { check: SLUGS.FACILITY.UPDATE, path: pFacility + '/:id/edit', component: facility.edit },
    { check: SLUGS.PROJECT.ROOT.CREATE, path: pFacility + '/:idFacility/add', component: ProjectAdd },

    // facility access
    { check: SLUGS.FACILITY.ACCESS.READ, path: pFacility + ID + '/access', component: facilityAccess.list },
    { check: SLUGS.FACILITY.ACCESS.READ, path: pFacility + ID + '/access' + ADD, component: facilityAccess.add },
    { check: SLUGS.FACILITY.ACCESS.READ, path: pFacility + ID + '/access/:idUser', component: facilityAccess.one },

    // form ks3
    { check: SLUGS.FACILITY.FORM_KS3.READ, path: pKs3, component: formks3.list },
    { check: SLUGS.FACILITY.FORM_KS3.MANAGE, path: pKs3 + ADD, component: formks3.add },
    { check: SLUGS.FACILITY.FORM_KS3.READ, path: pKs3 + '/:idDoc', component: formks3.one },
    // facility responsible persons 
    { check: SLUGS.FACILITY.RESP_PERSON.READ, path: pResponsiblePerson, component: facility.resList },
    { check: SLUGS.FACILITY.RESP_PERSON.MANAGE, path: pResponsiblePerson + ADD, component: facility.resAdd },
    { check: SLUGS.FACILITY.RESP_PERSON.READ, path: pResponsiblePerson + ID, component: facility.resOne },
    // facility machine 
    { check: SLUGS.FACILITY.MACHINE.READ, path: pFacilityMachine, component: facilityMachine.list },
    { check: SLUGS.FACILITY.MACHINE.MANAGE, path: pFacilityMachine + ADD, component: facilityMachine.add },
    // facility files 
    { check: SLUGS.FACILITY.FILES.READ, path: pFacilityFiles, component: facilityFiles.list },

    // journals cables
    { check: SLUGS.PROJECT.JOURNAL.READ, path: pJournalsCables, component: journalsCables.list },
    { check: SLUGS.PROJECT.JOURNAL.CREATE, path: pJournalsCables + ADD, component: journalsCables.add },
    { check: SLUGS.PROJECT.JOURNAL.READ, path: pJournalsCables + '/:idDoc', component: journalsCables.one },
    { check: SLUGS.PROJECT.JOURNAL.CREATE_RECORDS, path: pJournalsCables + '/:idDoc' + ADD, component: journalsCables.addRows },

    { check: SLUGS.CATALOG.EQUIPMENT.READ, path: pEquipment, component: equipment.list },
    { check: SLUGS.CATALOG.EQUIPMENT.MANAGE, path: pEquipment + ADD, component: equipment.add },
    { check: SLUGS.CATALOG.EQUIPMENT.READ, path: pEquipment + ID, component: equipment.edit },

    { check: SLUGS.CATALOG.READ, path: pStorageUnit, component: storageUnit.list },
    { check: SLUGS.CATALOG.CREATE, path: pStorageUnit + ADD, component: storageUnit.add },
    { check: SLUGS.CATALOG.READ, path: pStorageUnit + ID, component: storageUnit.edit },

    { check: SLUGS.CATALOG.READ, path: pPosition, component: position.list },
    { check: SLUGS.CATALOG.CREATE, path: pPosition + ADD, component: position.add },
    { check: SLUGS.CATALOG.READ, path: pPosition + ID, component: position.edit },

    { check: SLUGS.CATALOG.READ, path: pMachine, component: machine.list },
    { check: SLUGS.CATALOG.CREATE, path: pMachine + ADD, component: machine.add },
    { check: SLUGS.CATALOG.READ, path: pMachine + ID, component: machine.one },
    { check: SLUGS.CATALOG.UPDATE, path: pMachine + ID + '/edit', component: machine.edit },

    { check: SLUGS.CATALOG.READ, path: pMachine + ID + '/state' + ADD, component: machine.addState },
    { check: SLUGS.CATALOG.READ, path: pMachine + ID + '/checklist' + ADD, component: machine.addChecklist },
    { check: SLUGS.CATALOG.UPDATE, path: pMachine + ID + '/state/:idState/edit', component: machine.editState },

    { check: SLUGS.CATALOG.READ, path: pWorkTemplate, component: workTemplate.list },
    { check: SLUGS.CATALOG.CREATE, path: pWorkTemplate + ADD, component: workTemplate.add },
    { check: SLUGS.CATALOG.READ, path: pWorkTemplate + ID, component: workTemplate.edit },

    { check: SLUGS.CATALOG.READ, path: pCompanies, component: companies.list },
    { check: SLUGS.CATALOG.CREATE, path: pCompanies + ADD, component: companies.add },
    { check: SLUGS.CATALOG.READ, path: pCompanies + ID, component: companies.one },
    { check: SLUGS.CATALOG.UPDATE, path: pCompanies + ID + '/edit', component: companies.edit },

    { check: SLUGS.CATALOG.READ, path: pWorkEstimate, component: workEstimate.list },
    { check: SLUGS.CATALOG.CREATE, path: pWorkEstimate + '/nf' + ADD, component: workEstimate.add },
    { check: SLUGS.CATALOG.UPDATE, path: pWorkEstimate + '/nf' + ID, component: workEstimate.edit },
    { check: SLUGS.CATALOG.CREATE, path: pWorkEstimate + '/f' + ADD, component: workEstimate.addFolder },
    { check: SLUGS.CATALOG.UPDATE, path: pWorkEstimate + '/f' + ID, component: workEstimate.editFolder },

    { check: SLUGS.CATALOG.READ, path: pChecklist, component: checklist.list },
    { check: SLUGS.CATALOG.CREATE, path: pChecklist + ADD, component: checklist.add },
    { check: SLUGS.CATALOG.READ, path: pChecklist + ID, component: checklist.one },

    { check: SLUGS.CATALOG.READ, path: pResources, component: resources.list },
    { check: SLUGS.CATALOG.CREATE, path: pResources + '/nf' + ADD, component: resources.add },
    { check: SLUGS.CATALOG.UPDATE, path: pResources + '/nf' + ID, component: resources.edit },
    { check: SLUGS.CATALOG.CREATE, path: pResources + '/f' + ADD, component: resources.addFolder },
    { check: SLUGS.CATALOG.UPDATE, path: pResources + '/f' + ID, component: resources.editFolder },

    // our storage ------------------------------------------------------------------------------
    { path: API_BO + '/storagemenu', component: menu.ourStorage },

    { check: SLUGS.STORAGE.READ, path: sBldg, component: ourStorage.listStorage },
    { check: SLUGS.STORAGE.MANAGE, path: sBldg + ADD, component: ourStorage.addStorage },
    // { path: sBldg + '/:idStorage', component: ourStorage.oneStorage },
    { check: SLUGS.STORAGE.READ, path: sBldg + '/:idStorage', component: ourStorage.updStorage },

    { check: SLUGS.STORAGE.MATERIAL.MOVE_READ, path: sDocMoveProject, component: ourStorage.docMoveToProjectList },
    { check: SLUGS.STORAGE.MATERIAL.MOVE_MANAGE, path: sDocMoveProject + ADD, component: ourStorage.docMoveToProjectAdd },
    { check: SLUGS.STORAGE.MATERIAL.MOVE_READ, path: sDocMoveProject + '/:idDoc', component: ourStorage.docMoveToProjectById },

    { check: SLUGS.STORAGE.MATERIAL.ADD_READ, path: sDocAddMaterial, component: ourStorage.docMaterialAddList },
    { check: SLUGS.STORAGE.MATERIAL.ADD_MANAGE, path: sDocAddMaterial + ADD, component: ourStorage.docMaterialAddAdd },
    { check: SLUGS.STORAGE.MATERIAL.ADD_READ, path: sDocAddMaterial + '/:idDoc', component: ourStorage.docMaterialAddById },

    { check: SLUGS.STORAGE.READ, path: sReport + '/remains', component: ourStorage.reportRemains },
    // end our storage--------------------------------------------------------------------------------
    { check: SLUGS.CATALOG.WORKER.READ, path: workerPath, component: worker.list },
    { check: SLUGS.CATALOG.WORKER.READ, path: workerPath + '/report', component: worker.oneWork },
    { check: SLUGS.CATALOG.WORKER.MANAGE, path: workerPath + ADD, component: worker.add },
    { check: SLUGS.CATALOG.WORKER.READ, path: workerRatingPath, component: workerRating.list },
    { check: SLUGS.CATALOG.WORKER.MANAGE, path: workerRatingPath + ADD, component: workerRating.add },
    { check: SLUGS.CATALOG.WORKER.READ, path: workerRatingPath + ID, component: workerRating.one },
    { check: SLUGS.CATALOG.WORKER.READ, path: workerPath + ID, component: worker.one },
    { check: SLUGS.CATALOG.WORKER.MANAGE, path: workerPath + '/:id/edit', component: worker.edit },

    { check: SLUGS.CATALOG.READ, path: pTemplates, component: reportTemplates.list },
    { check: SLUGS.CATALOG.READ, path: pTemplates + ID, component: reportTemplates.one },

    { check: SLUGS.STORAGE.INVENTORY.READ, path: pInventory, component: InventoryList.list },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_READ, path: pInventoryMoveProject, component: InventoryList.movePList },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_MANAGE, path: pInventoryMoveProject + ADD, component: InventoryList.movePAdd },
    { check: SLUGS.STORAGE.INVENTORY.MOVE_READ, path: pInventoryMoveProject + ID, component: InventoryList.movePById },

    { check: SLUGS.PROJECT.ESTIMATE.READ, path: pEstimate, component: estimate.list },

    //share 
    { path: pShare + '/estimate', component: estimate.share },
    { path: pShare + '/gant', component: GantShare },

    { check: SLUGS.PROJECT.CALENDAR.READ, path: pCalendar, component: Calendar },

    //contractor 
    { check: SLUGS.PROJECT.CONTRACTOR.LIST, path: pContractor, component: contractor.main },
  ]
}
// заготовки не удалять 
//  check('storage:read',{id:idProject, accessId:idProject})&&{path:API_BO+'/projects/:id/storage/equipment', component: StorageMaterial},
//  check('storage:read',{id:idProject, accessId:idProject})&&{path:API_BO+'/projects/:id/storage/equipment/dynamics', component: StorageDynamics},
//  check('storage:read',{id:idProject, accessId:idProject})&&{path:API_BO+'/projects/:id/storage/arenda', component: StorageMaterial},
// check('inventory:read')&&{path:API_BO+'/inventory/:id', component: InventoryList.one},
// check('shipment:create')&&{path:API_BO+'/shipment/add', component: ShipmentAdd},
// check('equipment:read')&&{path:API_BO+'/projects/:idProject/shipment/arenda/:idShipment', component: ShipmentMaterial},